/**
 * @group Operations
 * @category Constructors
 */
const useOperation = key => {
  const constructor = input => {
    return {
      key,
      input
    };
  };
  constructor.key = key;
  return constructor;
};
const makeConfirmOptionsFinalizedOnMainnet = (metaplex, options) => {
  return metaplex.cluster === 'mainnet-beta' ? {
    ...options,
    commitment: 'finalized'
  } : options;
};

export { makeConfirmOptionsFinalizedOnMainnet, useOperation };
//# sourceMappingURL=Operation.mjs.map
